const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the content liked by component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 */
app.directive('updateSegmentation', ['Application', 'Users', function(Application, Users) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        managerConfiguration: '=',
        user: '=',
        teams: '=?',
        added: '&?',
        cancel: '&?'
      },
      template: require('../../../templates/directives/manager/update-segmentation.html'),
      controller: ['$scope', function($scope) {
          var self = this;
          if (!$scope.user || !$scope.user._id) {
            return $scope.cancel();
          }

          self.flags = Application.features.flags();
          self.creator = Application.access.user;
          self.managerRestricted = {};
          self.hideOptions = {};
          self.selections = {
            linked_teams: [],
            groups: []
          };

          var managerConfiguration = $scope.managerConfiguration || {};
          if (managerConfiguration.segmentation_subset && managerConfiguration.segmentation_subset.length) {
            managerConfiguration.segmentation_subset.forEach(function(item) {
              self.managerRestricted[item] = true;
            });
          }

          if (managerConfiguration.hide_options && managerConfiguration.hide_options.length) {
            managerConfiguration.hide_options.forEach(function(item) {
              self.hideOptions[item] = true;
            });
          }

          if (self.managerRestricted.linked_teams && (!self.creator.linked_teams || !self.creator.linked_teams.length)) {
            self.hideOptions.linked_teams = true;
          }

          if (self.hideOptions.groups && self.hideOptions.linked_teams) {
            return $scope.cancel();
          }

          self.onAdd = function() {
            if ($scope.added) {
              $scope.added();
            }
          };

          self.update = function() {

            Users.managerSegmentationUpdate({subsubresource: $scope.user._id}, self.selections).$promise
            .then(function(results) {
              Application.messaging.addMessage({type: 'success', duration: 5, text: 'The users was successfully updated.'});
              self.onAdd();
            }).catch(function(error) {
              console.log('errog in user update with segmentation: ', error);
            });
          };

          self.showModal= true;


        }],
      controllerAs: 'segmentation'
    };
  }]);

